import React from 'react';
import { Box, Card, makeStyles } from '@material-ui/core';
import { DraggableCardContent } from './DraggableCardContent';
import { DragHandle } from './DragHandle';
import { DraggableProvidedDragHandleProps, DraggableStateSnapshot } from 'react-beautiful-dnd';

const useStyles = makeStyles(theme => ({
    dragHandle: {
        position: 'absolute',
        left: -theme.spacing(2.5),
        top: theme.spacing(1.5),
    },
}));

export interface DraggableCardProps {
    dragHandleProps: DraggableProvidedDragHandleProps,
    dragHandleLabel: string;
    draggableState: DraggableStateSnapshot,
    children: React.ReactNode;
}

export const DraggableCard: React.FunctionComponent<DraggableCardProps> = props => {
    const classes = useStyles();
    // we need this Box so that the d'n'd placeholder assumes the correct height
    // whereas setting a margin on the Card would not have the correct effect
    return (
        <Box paddingBottom={2}>
            <Card elevation={props.draggableState.isDragging ? 6 : 1}>
                <DraggableCardContent position="relative">
                    <DragHandle
                        dragHandleProps={props.dragHandleProps}
                        className={classes.dragHandle}
                        aria-label={props.dragHandleLabel}
                    />
                    <div>
                        {props.children}
                    </div>
                </DraggableCardContent>
            </Card>
        </Box>
    );
};
